// extracted by mini-css-extract-plugin
export default {"root":"Faq-root","headWrap":"Faq-headWrap","question":"Faq-question","body":"Faq-body"};